import { createContext, useState, useContext } from 'react';
import type { ReactNode } from 'react';

type ViewType = 'overview' | 'trading' | 'positions' | 'charts';

interface ViewContextType {
  selectedView: ViewType;
  setSelectedView: (view: ViewType) => void;
}

const ViewContext = createContext<ViewContextType | undefined>(undefined);

export function ViewProvider({ children }: { children: ReactNode }) {
  const [selectedView, setSelectedView] = useState<ViewType>('positions');

  return (
    <ViewContext.Provider value={{ selectedView, setSelectedView }}>
      {children}
    </ViewContext.Provider>
  );
}

export function useView() {
  const context = useContext(ViewContext);
  if (!context) {
    throw new Error('useView must be used within a ViewProvider');
  }
  return context;
}
